export * from './speed-heart';

//# sourceMappingURL=index.js.map